import { render } from "./ContentTranslationPopUpComponent.vue?vue&type=template&id=468dd42e&scoped=true"
import script from "./ContentTranslationPopUpComponent.vue?vue&type=script&lang=js"
export * from "./ContentTranslationPopUpComponent.vue?vue&type=script&lang=js"

import "./ContentTranslationPopUpComponent.vue?vue&type=style&index=0&id=468dd42e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-468dd42e"

export default script